import type { DocumentConvertResult, DocumentVisibility } from "@gencow/core";
import { emitRagOperationMetrics, type RagMetricsDbLike } from "./rag-operations-metrics.js";

export async function emitCompletedRagIngestMetrics(params: {
  db: RagMetricsDbLike;
  corpus: string;
  visibility: DocumentVisibility;
  ownerUserId?: string | null;
  jobId: string;
  workflowId: string;
  sourceId: string;
  storageBytes: number;
  sectionCount: number;
  chunkCount: number;
  warningCount: number;
  providerTrace: DocumentConvertResult["providerTrace"];
  reindexMode?: string;
}): Promise<void> {
  const base = {
    corpus: params.corpus,
    visibility: params.visibility,
    ownerUserId: params.ownerUserId ?? null,
    operation: "ingest" as const,
    jobId: params.jobId,
    workflowId: params.workflowId,
    sourceId: params.sourceId,
  };
  const providerMetadata = {
    provider: params.providerTrace.provider,
    route: params.providerTrace.route,
    external: params.providerTrace.external,
    reindexMode: params.reindexMode ?? "if_changed",
  };

  await emitRagOperationMetrics(params.db, [
    {
      ...base,
      metricName: "source_bytes",
      metricValue: params.storageBytes,
      unit: "count",
      metadata: providerMetadata,
    },
    {
      ...base,
      metricName: "section_count",
      metricValue: params.sectionCount,
      unit: "count",
    },
    {
      ...base,
      metricName: "chunk_count",
      metricValue: params.chunkCount,
      unit: "count",
    },
    {
      ...base,
      metricName: "warning_count",
      metricValue: params.warningCount,
      unit: "count",
    },
    {
      ...base,
      metricName: "convert_latency_ms",
      metricValue: params.providerTrace.durationMs,
      unit: "ms",
    },
    {
      ...base,
      metricName: "external_provider_count",
      metricValue: params.providerTrace.external ? 1 : 0,
      unit: "count",
    },
  ]);
}
